export const CONTACT_TIER_OPTIONS = [
  { value: 'standard' },
  { value: 'premium' },
  { value: 'vip' },
  { value: 'vvip' },
];

export const getContactTierLabel = (tier, t) => {
  switch (tier) {
    case 'standard':
      return t('CONTACTS_LAYOUT.CONTACT_TIERS.STANDARD');
    case 'premium':
      return t('CONTACTS_LAYOUT.CONTACT_TIERS.PREMIUM');
    case 'vip':
      return t('CONTACTS_LAYOUT.CONTACT_TIERS.VIP');
    case 'vvip':
      return t('CONTACTS_LAYOUT.CONTACT_TIERS.VVIP');
    default:
      return '';
  }
};

export const buildContactTierOptions = t =>
  CONTACT_TIER_OPTIONS.map(option => ({
    label: getContactTierLabel(option.value, t),
    value: option.value,
  }));

export const getContactTierName = (tier, t) => getContactTierLabel(tier, t);
